// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kEivC","col":"styles_col__vs9Ij"};